import React from "react";
import TaxGroupGenericSkeleton from "./TaxGroupGenericSkeleton";

function TaxGroupDetailSkeleton() {
  return (
    <>
      <TaxGroupGenericSkeleton />
    </>
  );
}

export default TaxGroupDetailSkeleton;
